import { KeyRound } from 'lucide-react';
import { FormBody } from './formBody/formBody';
import DataActionReader from '@/components/ui/dataActionReader';
import { ComponentProps } from 'react';
import { SegmentDetail } from './segmentDetail';

export const SegmentBody = ({
  link,
  linkCreatedByAccount,
  traceId,
  workflowContext
}: ComponentProps<typeof SegmentDetail>) => {
  const { data, action } = link;

  // If data is of type string, it means it contains encrypted data.
  if (typeof data === 'string') {
    return (
      <div className="mb-3 flex">
        <dl className="border-border bg-accent grow-0 rounded-md border px-2 py-1">
          <dt className="mb-1 flex items-center text-[11px] font-bold tracking-wide">
            ACTION ENCRYPTED <KeyRound size={22} className="ml-2 shrink-0" />
          </dt>
        </dl>
      </div>
    );
  }

  const isDataTool = action && (action.dataImporter || action.dataEditor);

  if (isDataTool) {
    return <DataActionReader action={action} data={data} />;
  }

  return (
    <FormBody
      linkCreatedByAccount={linkCreatedByAccount}
      link={link}
      traceId={traceId}
      workflowContext={workflowContext}
    />
  );
};
